module.exports = __webpack_public_path__ + "img/car_sendai17.431d5a0f.jpg";